/** @flow */
import { merge } from "lodash-es";
import APImocks from "../../mocks/api";

import USERS from "../../mocks/data/users";
import TENANTS from "../../mocks/data/tenants";
import CONTENT_TYPES from "../../mocks/data/content_types";
import entriesInitialData from "../../mocks/data/entries";

import exportDemoConsulenza from "../../mocks/exports/demo_consulenza";

const AUTH_HEADER = { Authorization: "Bearer dummy" };

let ENTRIES = entriesInitialData;

const delay = () =>
  new Promise((resolve, reject) => setTimeout(resolve.bind(null, true), 250));

const getResponse = (statusCode, headers, payload) => ({
  status: statusCode,
  ok: statusCode === 200,
  headers,
  payload
});

const login = (method: string, { user }: any) => {
  let response;

  switch (method) {
    case "POST":
      const userData = USERS.find(
        data => data.email === user.email && data.password === user.password
      );

      if (userData) {
        response = getResponse(200, AUTH_HEADER, userData);
      } else {
        response = getResponse(
          401,
          AUTH_HEADER,
          APImocks.login.responses[method]["401"]
        );
      }

      break;
    default:
  }

  return response;
};

// users/ID
const users = (method: string, params: any, endpointParams: string[]) => {
  let response;

  let userId = endpointParams.length > 1 ? parseInt(endpointParams[1]) : null;

  switch (method) {
    case "GET":
      const userData = USERS.find(data => data.id === userId);

      if (userData) {
        response = getResponse(200, AUTH_HEADER, userData);
      } else {
        response = getResponse(404, AUTH_HEADER, {});
      }

      break;
    case "POST":
      for (let i in USERS) {
        if (USERS[i].id === userId) {
          USERS[i] = { ...USERS[i], ...params };
        }
      }

      response = getResponse(
        200,
        AUTH_HEADER,
        APImocks.users.responses[method][200]
      );

      break;
    default:
  }

  return response;
};

const related_entry = (
  method: string,
  params: any,
  endpointParams: string[]
) => {
  let response;

  let userId = endpointParams.length > 1 ? parseInt(endpointParams[1]) : null;
  let contentTypeId =
    endpointParams.length === 4 ? parseInt(endpointParams[3]) : null;

  switch (method) {
    case "GET":
      const relatedEntry = ENTRIES.find(
        data =>
          data.content_type_id === contentTypeId &&
          data.related_entity === "users" &&
          data.related_id === userId
      );

      response = getResponse(200, AUTH_HEADER, relatedEntry);

      break;
    default:
  }

  return response;
};

const tenants = (method: string, params: any) => {
  let statusCode = 200;

  return getResponse(statusCode, AUTH_HEADER, TENANTS);
};

const content_types = (
  method: string,
  params: any,
  endpointParams: string[]
) => {
  let response;
  const tenantId = endpointParams.length > 2 ? endpointParams[1] : null;
  const contentTypeId =
    endpointParams.length >= 4 ? parseInt(endpointParams[3]) : null;

  switch (method) {
    case "GET":
      if (!contentTypeId) {
        const tenantContentTypes = CONTENT_TYPES.filter(
          data => data.tenantId === tenantId
        );

        response = getResponse(200, AUTH_HEADER, tenantContentTypes);
      }
      break;
    default:
  }

  return response;
};

const entries = (method: string, params: any, endpointParams) => {
  let response;
  const contentTypeId =
    endpointParams.length >= 4 ? parseInt(endpointParams[3]) : null;

  switch (method) {
    case "GET":
      const entries = ENTRIES.filter(
        data => data.content_type_id === contentTypeId
      );

      response = getResponse(200, AUTH_HEADER, entries);

      break;
    case "POST":
      const newEntry = {
        id: ENTRIES.length,
        content_type_id: params.entry.content_type_id,
        data: params.entry.properties,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };

      ENTRIES.push(newEntry);

      response = getResponse(200, AUTH_HEADER, newEntry);

      break;
    default:
  }

  return response;
};

const entry = (method: string, params: any, endpointParams) => {
  let response;
  const entryId =
    endpointParams.length >= 6 ? parseInt(endpointParams[5]) : null;

  switch (method) {
    case "GET":
      const entry = ENTRIES.find(data => data.id === entryId);

      response = getResponse(200, AUTH_HEADER, entry);

      break;
    case "DELETE":
      ENTRIES = ENTRIES.filter(data => data.id !== entryId);

      response = getResponse(200, AUTH_HEADER, {});
      break;
    case "PUT":
      for (let i in ENTRIES) {
        if (ENTRIES[i].id === entryId) {
          ENTRIES[i].data = merge(ENTRIES[i].data, params.entry.properties);
          ENTRIES[i].updated_at = new Date().toISOString();

          response = getResponse(200, AUTH_HEADER, ENTRIES[i]);
        }
      }

      break;
    default:
  }

  return response;
};

const exports = (method: string, params: any, endpointParams) => {
  let payload;
  const contentTypeId =
    endpointParams.length >= 4 ? parseInt(endpointParams[3]) : null;

  if (contentTypeId === 6) {
    payload = JSON.parse(exportDemoConsulenza.demo_prospetto);
  }

  return getResponse(200, AUTH_HEADER, payload);
};

const getRawEndpoint = endpoint =>
  endpoint
    .split("/")
    .map((path, index) => (index % 2 === 0 ? path : "*"))
    .join("/");

// resource/ID/resource/ID ...

const parse = {
  login,
  "users/*": users,
  "users/*/related-entry/*": related_entry,
  tenants: tenants,
  "tenants/*/content_types": content_types,
  "tenants/*/content_types/*/entries": entries,
  "tenants/*/content_types/*/entries/*": entry,
  "tenants/*/content_types/*/exports": exports
};

const fakeFetch = (
  endpoint: string,
  requestInit: any
): Promise<{ ok: boolean, payload: {}, headers: {} }> => {
  return new Promise(async (resolve, reject) => {
    await delay();
    const response = parse[getRawEndpoint(endpoint)](
      requestInit.method,
      requestInit.body,
      endpoint.split("/")
    );

    resolve(response);
  });
};

export default fakeFetch;
